function getSleepyheadCurrentProductId() {
  return document.querySelector('product-info')?.dataset.productId
    || document.querySelector('[data-linked-products]')?.dataset.currentProductId
    || '';
}

function getSleepyheadMainProductVariantInputs() {
  const currentProductId = getSleepyheadCurrentProductId();
  if (!currentProductId) return [];

  return Array.from(
    document.querySelectorAll(`product-form[data-product-id="${currentProductId}"] form[action*="/cart/add"] input[name="id"]`)
  );
}

function updateSleepyheadMainProductVariantInputs(variantId) {
  getSleepyheadMainProductVariantInputs().forEach((input) => {
    input.value = variantId;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
}

// Variant Modal Handler
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  function domReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  }

  // Cache DOM queries
  const cache = {};
  
  function getElement(id) {
    return cache[id] || (cache[id] = document.getElementById(id));
  }
  
  function getElements(selector) {
    return cache[selector] || (cache[selector] = document.querySelectorAll(selector));
  }

  // Wait for productVariants to be available
  function whenReady(cb) {
    if (window.productVariants?.length) return cb();
    
    let attempts = 0;
    const timer = setInterval(() => {
      if (window.productVariants?.length || ++attempts > 30) {
        clearInterval(timer);
        if (window.productVariants?.length) cb();
      }
    }, 50);
  }

  function init() {
    const modal = getElement('variant-modal');
    if (!modal) return;

    const previews = getElements('.variant-preview');
    const closeBtn = getElement('variant-close');
    const applyBtn = getElement('variant-apply');
    const overlay = modal.querySelector('.variant-modal-overlay');
    const optionItems = Array.from(modal.querySelectorAll('.option-item'));
    const optionNames = window.productOptions || [];
    const variants = window.productVariants || [];
    const optionCount = optionNames.length || 0;
    const optionItemsByIndex = {};

    let selected = new Array(optionCount);
    let savedSelected = [];

    optionItems.forEach((item) => {
      const idx = Number(item.dataset.optionIndex);
      if (!Number.isNaN(idx)) {
        optionItemsByIndex[idx] = optionItemsByIndex[idx] || [];
        optionItemsByIndex[idx].push(item);
      }
    });

    if (!modal.dataset.firstOptionGroupType && optionNames.length) {
      modal.dataset.firstOptionGroupType = 'variant';
      modal.dataset.firstOptionGroupName = optionNames[0];
    }

    function normalizeLinkedValue(rawValue) {
      if (rawValue == null) return '';
      let value = String(rawValue).trim();
      if (!value) return '';

      const hexRegex = /#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})/i;

      if (value.includes(':')) {
        const parts = value.split(':').map((part) => part.trim()).filter(Boolean);
        if (parts.length >= 2) {
          if (hexRegex.test(parts[parts.length - 1])) {
            parts.pop();
          }
          return parts[1] || parts[0] || '';
        }
      }

      value = value
        .replace(/\(\s*#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})\s*\)/i, '')
        .replace(/\s+#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})/i, '')
        .trim();

      return value;
    }

    function normalizeLinkedValues(values) {
      if (!Array.isArray(values)) return [];
      return values.map(normalizeLinkedValue).filter(Boolean);
    }

    function getVariantOptionValue(variant, index) {
      return Array.isArray(variant?.options) ? variant.options[index] : null;
    }

    function isVariantPurchasable(variant) {
      if (!variant) return false;
      if (variant.available) return true;
      return variant.inventory_policy === 'continue';
    }

    function isFirstVariantGroup(index) {
      if (modal.dataset.firstOptionGroupType !== 'variant') return false;
      return modal.dataset.firstOptionGroupName === optionNames[index];
    }

    function findMatchingVariants(optionIndex, optionValue, useSelections) {
      return variants.filter((variant) => {
        if (String(getVariantOptionValue(variant, optionIndex)) !== String(optionValue)) {
          return false;
        }
        return optionNames.every((_, idx) => {
          if (idx === optionIndex) return true;
          if (!useSelections) return true;
          const selectedValue = selected[idx];
          if (!selectedValue) return true;
          return String(getVariantOptionValue(variant, idx)) === String(selectedValue);
        });
      });
    }

    function isOptionPurchasable(optionIndex, optionValue, useSelections) {
      const matches = findMatchingVariants(optionIndex, optionValue, useSelections);
      if (!matches.length) return false;
      return matches.some(isVariantPurchasable);
    }

    function getFirstAvailableValue(optionIndex, useSelections) {
      const items = optionItemsByIndex[optionIndex] || [];
      const values = items.map((item) => item.dataset.value).filter(Boolean);
      return values.find((value) => isOptionPurchasable(optionIndex, value, useSelections)) || null;
    }

    function findMatchingVariant() {
      return variants.find((variant) => {
        return optionNames.every((_, idx) => {
          if (!selected[idx]) return true;
          return String(getVariantOptionValue(variant, idx)) === String(selected[idx]);
        });
      });
    }

    function findVariantByOptions(options) {
      return variants.find((variant) => {
        return optionNames.every((_, idx) => {
          return String(getVariantOptionValue(variant, idx)) === String(options[idx]);
        });
      });
    }

    function isPairCompatible(indexA, valueA, indexB, valueB) {
      return variants.some((variant) => {
        return (
          String(getVariantOptionValue(variant, indexA)) === String(valueA) &&
          String(getVariantOptionValue(variant, indexB)) === String(valueB)
        );
      });
    }

    // Hierarchical matching: find variants matching optionValue at optionIndex,
    // constrained ONLY by selected values at indices BEFORE optionIndex.
    // This ensures option1 → option2 → option3 one-directional cascade.
    function findUpstreamMatchingVariants(optionIndex, optionValue) {
      return variants.filter((variant) => {
        if (String(getVariantOptionValue(variant, optionIndex)) !== String(optionValue)) {
          return false;
        }
        for (let i = 0; i < optionIndex; i++) {
          if (selected[i] && String(getVariantOptionValue(variant, i)) !== String(selected[i])) {
            return false;
          }
        }
        return true;
      });
    }

    function getLinkedSelections() {
      const selections = Array.from(modal.querySelectorAll('.linked-option-item[aria-pressed="true"]'))
        .map((btn) => btn.dataset.optionValue || btn.textContent.trim())
        .filter(Boolean);
      if (selections.length) return normalizeLinkedValues(selections);

      const fallback = modal?.dataset?.linkedSelections;
      if (!fallback) return [];
      try {
        const parsed = JSON.parse(fallback);
        return Array.isArray(parsed) ? normalizeLinkedValues(parsed) : [];
      } catch (error) {
        return [];
      }
    }

    function getPreviewLinkedSelections(previewEl) {
      const raw = previewEl?.dataset?.linkedOptions;
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? normalizeLinkedValues(parsed) : [];
      } catch (error) {
        return [];
      }
    }

    function getVirtualSelections(previewEl) {
      const raw = previewEl?.dataset?.virtualOptions;
      if (!raw) return [];
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? normalizeLinkedValues(parsed) : [];
      } catch (error) {
        return [];
      }
    }

    function buildPreviewLabel(previewEl) {
      const hasOnlyDefault = previewEl?.dataset?.hasOnlyDefaultVariant === 'true';
      const defaultTitle = previewEl?.dataset?.defaultTitle || '';
      const productTitle = previewEl?.dataset?.productTitle || '';

      const linkedValues = Array.from(new Set([
        ...getLinkedSelections(),
        ...getPreviewLinkedSelections(previewEl),
      ])).filter(Boolean);
      const virtualValues = getVirtualSelections(previewEl);
      const linkedVariantMode = modal?.dataset?.linkedVariantMode === 'true';

      if (linkedVariantMode) {
        const combined = [...virtualValues, ...linkedValues].filter(Boolean);
        if (combined.length) return combined.join(' / ');
        return defaultTitle || productTitle || 'Select options';
      }

      if (hasOnlyDefault) {
        const combined = [...virtualValues, ...linkedValues].filter(Boolean);
        if (combined.length) return combined.join(' / ');
        return defaultTitle || 'Select options';
      }

      const variantValues = selected.filter(Boolean);
      const combined = [...virtualValues, ...linkedValues, ...variantValues].filter(Boolean);

      if (combined.length) return combined.join(' / ');
      return defaultTitle || 'Select options';
    }

    function updatePreviewLabel() {
      previews.forEach((preview) => {
        preview.innerHTML = `<p>${buildPreviewLabel(preview)}</p>`;
      });
    }

    // Cascade selections from primaryIndex downward.
    // Options at indices <= primaryIndex are kept as-is.
    // Options at indices > primaryIndex are resolved in order,
    // each constrained only by options before it (upstream).
    function cascadeSelections(primaryIndex) {
      for (let idx = 0; idx < optionCount; idx++) {
        if (idx <= primaryIndex) continue;

        const currentValue = selected[idx];

        // Keep current value if it has purchasable variants given upstream options
        if (currentValue) {
          const upstreamMatches = findUpstreamMatchingVariants(idx, currentValue);
          if (upstreamMatches.some(isVariantPurchasable)) continue;
        }

        // Find first purchasable value given upstream selections
        const items = optionItemsByIndex[idx] || [];
        let found = false;
        for (let j = 0; j < items.length; j++) {
          const val = items[j].dataset.value;
          if (!val) continue;
          const matches = findUpstreamMatchingVariants(idx, val);
          if (matches.some(isVariantPurchasable)) {
            selected[idx] = val;
            found = true;
            break;
          }
        }

        // Fallback: first existing value (even if sold out)
        if (!found) {
          for (let j = 0; j < items.length; j++) {
            const val = items[j].dataset.value;
            if (!val) continue;
            if (findUpstreamMatchingVariants(idx, val).length > 0) {
              selected[idx] = val;
              found = true;
              break;
            }
          }
        }

        if (!found) {
          selected[idx] = null;
        }
      }
    }

    // Validate and fill selections using hierarchical (upstream-only) constraints.
    // Processes options in order: option1 → option2 → option3.
    // Each option is constrained only by options before it.
    function normalizeSelections() {
      for (let idx = 0; idx < optionCount; idx++) {
        const currentValue = selected[idx];
        const items = optionItemsByIndex[idx] || [];

        // Keep current value if it exists for the upstream combination
        if (currentValue) {
          const upstreamMatches = findUpstreamMatchingVariants(idx, currentValue);
          if (upstreamMatches.length > 0) continue;
        }

        // Find first purchasable value given upstream selections
        let found = false;
        for (let j = 0; j < items.length; j++) {
          const val = items[j].dataset.value;
          if (!val) continue;
          const matches = findUpstreamMatchingVariants(idx, val);
          if (matches.some(isVariantPurchasable)) {
            selected[idx] = val;
            found = true;
            break;
          }
        }

        // Fallback: first existing value (even if sold out)
        if (!found) {
          for (let j = 0; j < items.length; j++) {
            const val = items[j].dataset.value;
            if (!val) continue;
            if (findUpstreamMatchingVariants(idx, val).length > 0) {
              selected[idx] = val;
              found = true;
              break;
            }
          }
        }

        if (!found) {
          selected[idx] = null;
        }
      }
    }

    // Update variant option UI using hierarchical constraints:
    // - option1 (idx 0): shows ALL values, disables sold-out ones
    // - option2 (idx 1): shows values that EXIST for selected option1, disables sold-out
    // - option3 (idx 2): shows values that EXIST for selected option1+option2, disables sold-out
    function updateVariantOptionUI() {
      optionNames.forEach((_, idx) => {
        const isFirstGroup = idx === 0;
        const items = optionItemsByIndex[idx] || [];

        items.forEach((item) => {
          const value = item.dataset.value;
          const matches = findUpstreamMatchingVariants(idx, value);
          const exists = matches.length > 0;
          const purchasable = matches.some(isVariantPurchasable);
          const shouldHide = !exists && !isFirstGroup;
          const shouldDisable = isFirstGroup ? !purchasable : (exists && !purchasable);

          item.hidden = shouldHide;
          item.classList.toggle('option-item--unavailable', shouldDisable);
          item.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
          item.setAttribute('tabindex', shouldDisable ? '-1' : '0');
        });
      });

      optionNames.forEach((_, idx) => {
        const items = optionItemsByIndex[idx] || [];
        items.forEach((item) => {
          item.classList.toggle('active', item.dataset.value === String(selected[idx]));
        });
      });
    }

    // Pre-fill current variant from URL param if present
    const urlParams = new URLSearchParams(window.location.search);
    const urlVariantId = urlParams.get('variant') || urlParams.get('variant_id');
    let current;
    if (urlVariantId) {
      current = variants.find(v => String(v.id) === String(urlVariantId));
    }
    if (!current) {
      current = variants.find(v => v.available) || variants[0];
    }
    if (current?.options) {
      selected = [...current.options];
    }
    normalizeSelections();
    updateVariantOptionUI();
    updatePreviewLabel();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variant = data?.variant;
        if (!variant) return;
        previews.forEach(p => {
          p.dataset.variantId = variant.id;
        });
        if (variant.options) {
          selected = [...variant.options];
          normalizeSelections();
          updateVariantOptionUI();
          updatePreviewLabel();
        }
      });
    }

    // Toggle modal
    function toggle(show) {
      if (show) {
        // Save current selections so we can restore on close/cancel
        savedSelected = [...selected];
      }
      modal.setAttribute('aria-hidden', !show);
      modal.style.display = show ? 'block' : 'none';
    }

    // Event delegation for previews
    document.addEventListener('click', e => {
      const preview = e.target.closest('.variant-preview');
      if (preview) toggle(true);
    }, { passive: true });

    // Close/cancel: restore pre-open state and close
    function closeModal() {
      selected = [...savedSelected];
      normalizeSelections();
      updateVariantOptionUI();
      // Reset linked options to match current product
      modal.dispatchEvent(new CustomEvent('linked-options:reset'));
      updatePreviewLabel();
      toggle(false);
    }

    [closeBtn, overlay].forEach(el => 
      el?.addEventListener('click', closeModal, { passive: true })
    );

    // Option selection with event delegation
    modal.addEventListener('click', e => {
      const item = e.target.closest('.option-item');
      if (!item) return;
      if (item.hidden || item.classList.contains('option-item--unavailable') || item.getAttribute('aria-disabled') === 'true') {
        return;
      }

      const idx = +item.dataset.optionIndex;
      selected[idx] = item.dataset.value;
      cascadeSelections(idx);
      updateVariantOptionUI();

    });

    modal.addEventListener('linked-options:change', () => {
      updatePreviewLabel();
    });

    // Keyboard support
    modal.addEventListener('keydown', e => {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('option-item')) {
        if (e.target.getAttribute('aria-disabled') === 'true' || e.target.classList.contains('option-item--unavailable')) {
          return;
        }
        e.preventDefault();
        e.target.click();
      }
    });

    // Apply selection
    applyBtn?.addEventListener('click', () => {
      normalizeSelections();
      updateVariantOptionUI();
      if (selected.some(v => !v)) return;

      let targetVariant = findVariantByOptions(selected);
      if (!targetVariant) {
        const partialMatch = findMatchingVariant();
        if (partialMatch?.options) {
          selected = [...partialMatch.options];
          normalizeSelections();
          updateVariantOptionUI();
          targetVariant = findVariantByOptions(selected) || partialMatch;
        }
      }
      if (!targetVariant) return;

      // Batch all DOM updates
      requestAnimationFrame(() => {
        const productInfoRoot = document.querySelector('product-info') || document;

        // Update selects
        productInfoRoot.querySelectorAll('select[name^="options["]').forEach(sel => {
          const match = sel.name.match(/^options\[(.*)\]$/);
          if (match) {
            const idx = optionNames.indexOf(match[1]);
            if (idx !== -1 && targetVariant.options?.[idx]) {
              sel.value = targetVariant.options[idx];
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        });

        // Update radio buttons (swatch/pill pickers)
        optionNames.forEach((optionName, idx) => {
          const optionValue = targetVariant.options?.[idx];
          if (!optionValue) return;
          const escapedName = window.CSS?.escape ? CSS.escape(`${optionName}-`) : `${optionName}-`.replace(/"/g, '\\"');

          productInfoRoot.querySelectorAll(`variant-selects input[type="radio"][name^="${escapedName}"]`).forEach((input) => {
            if (String(input.value) !== String(optionValue)) return;
            if (!input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });

        updateSleepyheadMainProductVariantInputs(targetVariant.id);

        if (targetVariant?.id) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', targetVariant.id);
          window.history.replaceState({}, '', url.toString());
        }

        previews.forEach((preview) => {
          preview.dataset.variantId = targetVariant.id;
        });

        // Directly update deal offer bar for the new variant
        if (typeof window.__updateDealOffer === 'function') {
          window.__updateDealOffer(targetVariant.id);
        }

        updatePreviewLabel();
        toggle(false);
      });
    }, { passive: true });
  }

  // Initialize when both DOM and productVariants are ready
  domReady(function() {
    whenReady(init);
  });
})();

// Product information table (variant-aware)
(function() {
  'use strict';

  function domReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  }

  function coerceInfoList(value) {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    const raw = String(value).trim();
    if (!raw) return [];
    if (raw.startsWith('[')) {
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) return parsed;
      } catch (error) {
        // fall through to delimiter parsing
      }
    }
    if (raw.includes('|')) return raw.split('|');
    return [raw];
  }

  function parseInfoList(value) {
    return coerceInfoList(value)
      .map((entry) => (entry == null ? '' : String(entry)).trim())
      .filter(Boolean);
  }

  function buildRows(variantList, productList) {
    const rows = [];
    const usedKeys = new Set();

    function pushEntry(entry) {
      const idx = entry.indexOf(':');
      if (idx === -1) return;
      const key = entry.slice(0, idx).trim();
      const value = entry.slice(idx + 1).trim();
      if (!key || !value || usedKeys.has(key)) return;
      usedKeys.add(key);
      rows.push({ key, value });
    }

    parseInfoList(variantList).forEach(pushEntry);
    parseInfoList(productList).forEach(pushEntry);

    return rows;
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getVariantInfoFromVariant(variant) {
    if (!variant) return [];
    const raw =
      variant?.metafields?.custom?.variant_information ??
      variant?.metafields?.variant_information ??
      variant?.variant_information ??
      variant?.variantInformation ??
      null;
    const value = raw?.value ?? raw;
    return parseInfoList(value);
  }

  function resolveVariantInfo(wrapper, variantId) {
    const variantMap = parseJson(wrapper.dataset.variantInfoMap);
    if (Array.isArray(variantMap) && variantMap.length) {
      const match = variantMap.find((entry) => String(entry.id) === String(variantId));
      if (match?.info != null) return parseInfoList(match.info);
    }

    const variants = window.productVariants || [];
    const variant = variants.find((entry) => String(entry.id) === String(variantId));
    return getVariantInfoFromVariant(variant);
  }

  function renderTable(wrapper, rows) {
    if (!wrapper) return;
    let table = wrapper.querySelector('table');
    if (!table) {
      table = document.createElement('table');
      table.className = 'product-info-table';
      wrapper.appendChild(table);
    }

    let tbody = table.querySelector('tbody');
    if (!tbody) {
      tbody = document.createElement('tbody');
      table.appendChild(tbody);
    }

    if (!rows.length) {
      tbody.innerHTML = '';
      table.style.display = 'none';
      return;
    }

    table.style.display = '';
    tbody.innerHTML = rows
      .map((row) => `<tr><th>${row.key}</th><td>${row.value}</td></tr>`)
      .join('');
  }

  function updateForVariant(variantId) {
    const wrappers = document.querySelectorAll('.product-info-table-wrapper');
    wrappers.forEach((wrapper) => {
      const productInfoRaw = parseJson(wrapper.dataset.productInfo) ?? wrapper.dataset.productInfo;
      const productInfo = parseInfoList(productInfoRaw);
      const variantInfo = resolveVariantInfo(wrapper, variantId);
      const rows = buildRows(variantInfo, productInfo);
      renderTable(wrapper, rows);
    });
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function init() {
    if (!document.querySelector('.product-info-table-wrapper')) return;
    const initialVariantId = getCurrentVariantId();
    if (initialVariantId) {
      updateForVariant(initialVariantId);
    }

    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.closest('.variant-selector')) {
        const variantId = e.target.value;
        if (variantId) updateForVariant(variantId);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variantId = data?.variant?.id;
        if (variantId) updateForVariant(variantId);
      });
    }
  }

  domReady(init);
})();

// Deal offer bar (variant-aware)
(function() {
  'use strict';

  function domReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  }

  function parseJson(value) {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function resolveDealText(wrapper, variantId) {
    const productDeal = (wrapper.dataset.productDeal || '').trim();
    const variantMap = parseJson(wrapper.dataset.variantDealMap) || [];
    const match = variantMap.find((entry) => String(entry.id) === String(variantId));
    const variantDeal = (match?.text || '').trim();
    return variantDeal || productDeal;
  }

  function updateDealOffer(variantId) {
    const wrappers = document.querySelectorAll('[data-deal-offer]');
    if (!wrappers.length) return;

    wrappers.forEach((wrapper) => {
      const dealText = resolveDealText(wrapper, variantId);
      const textEl = wrapper.querySelector('[data-deal-offer-text]') || wrapper;

      if (!dealText) {
        wrapper.style.display = 'none';
        return;
      }

      wrapper.style.display = '';
      if (textEl) {
        textEl.innerHTML = dealText;
      }
    });
  }

  // Expose globally so the variant modal Apply handler can call it directly
  window.__updateDealOffer = updateDealOffer;

  function init() {
    if (!document.querySelector('[data-deal-offer]')) return;

    const initialVariantId = getCurrentVariantId();
    if (initialVariantId) {
      updateDealOffer(initialVariantId);
    }

    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.closest('.variant-selector')) {
        const variantId = e.target.value;
        if (variantId) updateDealOffer(variantId);
      }
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variantId = data?.variant?.id;
        if (variantId) updateDealOffer(variantId);
      });
    }
  }

  domReady(init);
})();

// Linked products options inside variant modal
(function() {
  'use strict';

  function domReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  }

  function parseOptions(optionsString) {
    if (!optionsString) return [];
    const trimmed = optionsString.trim();

    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    }

    return trimmed.split('|').reduce((acc, pair) => {
      const parts = pair.split(':');
      const key = parts[0];
      const value = parts.slice(1).join(':');
      if (key && value) {
        acc.push({ name: key.trim(), value: value.trim() });
      }
      return acc;
    }, []);
  }

  function normalizeOptionEntry(option) {
    if (!option) return null;
    const normalized = { ...option };
    const name = option.name != null ? String(option.name).trim() : '';
    const value = option.value != null ? String(option.value).trim() : '';
    const color = option.color != null ? String(option.color).trim() : '';
    const image = option.image != null ? String(option.image).trim() : '';

    normalized.name = name;
    normalized.value = value;
    normalized.color = color;
    normalized.image = image;

    const nameLower = name.toLowerCase();
    const isColorOption = Boolean(normalized.color) || nameLower.includes('color') || nameLower.includes('colour');
    const hexRegex = /#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})/i;
    const hexMatch = value.match(hexRegex);
    if (hexMatch && isColorOption) {
      if (!normalized.color) {
        normalized.color = hexMatch[0];
      }
      const cleaned = value
        .replace(/\(\s*#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})\s*\)/i, '')
        .replace(/\s*[:\-\|]\s*#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})/i, '')
        .replace(/\s+#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})/i, '')
        .trim();
      if (cleaned) {
        normalized.value = cleaned;
      }
    }

    return normalized;
  }

  function formatLabel(label) {
    if (!label) return '';
    const normalized = label.replace(/[_-]+/g, ' ').trim().toLowerCase();
    const overrides = {
      'shopify color pattern': 'Color',
      'color pattern': 'Color',
      color: 'Color',
    };
    if (overrides[normalized]) return overrides[normalized];
    return normalized.replace(/\b\w/g, (match) => match.toUpperCase());
  }

  function initLinkedOptionsModal() {
    const modal = document.getElementById('variant-modal');
    if (!modal || modal.dataset.linkedOptionsInit === 'true') return;
    modal.dataset.linkedOptionsInit = 'true';

    const dataContainer = modal.querySelector('[data-linked-products]');
    const optionsContainer = modal.querySelector('[data-linked-options]');
    if (!dataContainer || !optionsContainer) return;

    const items = Array.from(dataContainer.querySelectorAll('[data-linked-product]'));
    if (!items.length) return;
    const variantMode = items.some((item) => item.dataset.variantId);

    const state = {
      items,
      optionsContainer,
      currentProductId: dataContainer.dataset.currentProductId || '',
      selections: {},
      optionValues: {},
      optionOrder: [],
      modal,
      variantMode,
    };

    if (state.variantMode) {
      modal.dataset.linkedVariantMode = 'true';
      modal.querySelectorAll('.variant-group').forEach((group) => {
        group.hidden = true;
      });
    }

    function isItemPurchasable(item) {
      if (!item) return false;
      const available = item.dataset.variantAvailable === 'true';
      const policy = item.dataset.inventoryPolicy || '';
      if (policy === 'continue') return true;
      return available;
    }

    function isFirstLinkedGroup(optionName) {
      return (
        state.modal?.dataset.firstOptionGroupType === 'linked' &&
        state.modal?.dataset.firstOptionGroupName === optionName
      );
    }

    function getOptionIndex(optionName) {
      return state.optionOrder.indexOf(optionName);
    }

    function findMatchingItems(optionName, optionValue, useSelections) {
      return state.items.filter((item) => {
        const optionMap = item._optionMap || {};
        if (optionMap[optionName] !== optionValue) return false;
        return state.optionOrder.every((key) => {
          if (key === optionName) return true;
          if (!useSelections) return true;
          if (!state.selections[key]) return true;
          return optionMap[key] === state.selections[key];
        });
      });
    }

    function findUpstreamMatchingItems(optionName, optionValue) {
      const optionIndex = getOptionIndex(optionName);
      return state.items.filter((item) => {
        const optionMap = item._optionMap || {};
        if (optionMap[optionName] !== optionValue) return false;
        for (let i = 0; i < optionIndex; i++) {
          const upstreamName = state.optionOrder[i];
          const upstreamValue = state.selections[upstreamName];
          if (upstreamValue && optionMap[upstreamName] !== upstreamValue) {
            return false;
          }
        }
        return true;
      });
    }

    function isOptionPurchasable(optionName, optionValue, useSelections) {
      const matches = useSelections
        ? findUpstreamMatchingItems(optionName, optionValue)
        : findMatchingItems(optionName, optionValue, false);
      if (!matches.length) return false;
      return matches.some(isItemPurchasable);
    }

    function buildState() {
      state.items.forEach((item) => {
        const options = parseOptions(item.dataset.productOptions);
        item._optionMap = {};

        options.forEach((option) => {
          const normalized = normalizeOptionEntry(option);
          if (!normalized?.name || !normalized?.value) return;
          const name = normalized.name;
          const value = normalized.value;

          item._optionMap[name] = value;

          if (!state.optionOrder.includes(name)) {
            state.optionOrder.push(name);
          }

          if (!state.optionValues[name]) {
            state.optionValues[name] = {};
          }

          if (!state.optionValues[name][value]) {
            state.optionValues[name][value] = {
              value,
              image: normalized.image || '',
              color: normalized.color || '',
            };
          }
        });
      });

      const currentVariantId = getCurrentVariantId();
      const currentItem = state.items.find(
        (item) =>
          item.dataset.productId === state.currentProductId &&
          (!currentVariantId || String(item.dataset.variantId) === String(currentVariantId))
      ) || state.items.find(
        (item) => item.dataset.productId === state.currentProductId && isItemPurchasable(item)
      ) || state.items.find(
        (item) => item.dataset.productId === state.currentProductId
      ) || state.items[0];

      if (currentItem?._optionMap) {
        state.optionOrder.forEach((key) => {
          if (currentItem._optionMap[key]) {
            state.selections[key] = currentItem._optionMap[key];
          }
        });
      }

      if (state.optionOrder.length) {
        state.modal.dataset.firstOptionGroupType = 'linked';
        state.modal.dataset.firstOptionGroupName = state.optionOrder[0];
      }
    }

    function matchesSelections(optionMap, requireComplete) {
      return state.optionOrder.every((key) => {
        if (!state.selections[key]) return !requireComplete;
        return optionMap[key] === state.selections[key];
      });
    }

    function findMatchingItem(requireComplete = false) {
      return state.items.find((item) => matchesSelections(item._optionMap || {}, requireComplete)) || null;
    }

    function isOptionAvailable(optionName, optionValue, useSelections) {
      return isOptionPurchasable(optionName, optionValue, useSelections);
    }

    function getFirstMatchingValue(optionName, requirePurchasable) {
      const values = Object.values(state.optionValues[optionName] || {});
      const match = values.find((optionData) => {
        const matches = findUpstreamMatchingItems(optionName, optionData.value);
        if (!matches.length) return false;
        return requirePurchasable ? matches.some(isItemPurchasable) : true;
      });
      return match?.value || null;
    }

    function normalizeSelections() {
      state.optionOrder.forEach((optionName) => {
        const currentValue = state.selections[optionName];
        if (currentValue) {
          const matches = findUpstreamMatchingItems(optionName, currentValue);
          if (matches.some(isItemPurchasable)) return;
        }

        const fallbackValue =
          getFirstMatchingValue(optionName, true) ||
          getFirstMatchingValue(optionName, false);

        if (fallbackValue) {
          state.selections[optionName] = fallbackValue;
        } else {
          delete state.selections[optionName];
        }
      });
    }

    function cascadeSelections(primaryOptionName) {
      const primaryIndex = getOptionIndex(primaryOptionName);
      if (primaryIndex === -1) {
        normalizeSelections();
        return;
      }

      for (let i = primaryIndex + 1; i < state.optionOrder.length; i++) {
        const optionName = state.optionOrder[i];
        const currentValue = state.selections[optionName];
        if (currentValue) {
          const matches = findUpstreamMatchingItems(optionName, currentValue);
          if (matches.some(isItemPurchasable)) continue;
        }

        const fallbackValue =
          getFirstMatchingValue(optionName, true) ||
          getFirstMatchingValue(optionName, false);

        if (fallbackValue) {
          state.selections[optionName] = fallbackValue;
        } else {
          delete state.selections[optionName];
        }
      }
    }

    function renderOptions() {
      optionsContainer.innerHTML = '';
      normalizeSelections(false);

      state.optionOrder.forEach((optionName) => {
        const group = document.createElement('div');
        group.className = 'linked-options-group';

        const label = document.createElement('div');
        label.className = 'linked-options-label';
        label.textContent = formatLabel(optionName);

        const list = document.createElement('div');
        list.className = 'linked-option-list';

        const isFirstGroup = isFirstLinkedGroup(optionName);
        const useSelections = !isFirstGroup;

        Object.values(state.optionValues[optionName] || {}).forEach((optionData) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'linked-option-item';
          button.dataset.optionName = optionName;
          button.dataset.optionValue = optionData.value;
          if (optionData.color) {
            button.dataset.optionColor = optionData.color;
          }
          if (optionData.image) {
            button.dataset.optionImage = optionData.image;
          }
          button.setAttribute(
            'aria-pressed',
            state.selections[optionName] === optionData.value ? 'true' : 'false'
          );

          const matches = useSelections
            ? findUpstreamMatchingItems(optionName, optionData.value)
            : findMatchingItems(optionName, optionData.value, false);
          const exists = matches.length > 0;
          const purchasable = matches.some(isItemPurchasable);
          if (!exists && !isFirstGroup) {
            return;
          }
          if (!purchasable) {
            button.classList.add('linked-option-item--unavailable');
            button.setAttribute('aria-disabled', 'true');
            button.disabled = true;
          }

          if (optionData.image || optionData.color) {
            const swatch = document.createElement('span');
            swatch.className = 'option-swatch';
            if (optionData.image) {
              swatch.style.backgroundImage = `url("${optionData.image}")`;
            } else {
              swatch.style.backgroundColor = optionData.color;
            }
            button.appendChild(swatch);
          }
          const text = document.createElement('span');
          text.className = 'option-text';
          text.textContent = optionData.value;
          button.appendChild(text);

          list.appendChild(button);
        });

        group.appendChild(label);
        group.appendChild(list);
        optionsContainer.appendChild(group);
      });

      updateSelectionDataset();
      state.modal?.dispatchEvent(new CustomEvent('linked-options:change'));
    }

    function updateSelectionDataset() {
      if (!state.modal) return;
      const values = state.optionOrder
        .map((optionName) => state.selections[optionName])
        .filter(Boolean);
      const matching = findMatchingItem(true) || findMatchingItem(false);
      state.modal.dataset.linkedSelections = JSON.stringify(values);
      state.modal.dataset.linkedVariantId = matching?.dataset.variantId || '';
      state.modal.dataset.linkedProductId = matching?.dataset.productId || '';
      state.modal.dataset.linkedProductUrl = matching?.dataset.productUrl || '';
    }

    optionsContainer.addEventListener('click', (event) => {
      const button = event.target.closest('.linked-option-item');
      if (!button || button.disabled) return;
      const optionName = button.dataset.optionName;
      const optionValue = button.dataset.optionValue;
      if (!optionName || !optionValue) return;
      state.selections[optionName] = optionValue;
      cascadeSelections(optionName);
      renderOptions();
    });

    function getCurrentVariantId() {
      const params = new URLSearchParams(window.location.search);
      const urlVariantId = params.get('variant') || params.get('variant_id');
      if (urlVariantId) return urlVariantId;
      const input = getSleepyheadMainProductVariantInputs()[0];
      return input?.value || '';
    }

    function buildVariantUrl(productUrl, variantId) {
      const url = new URL(productUrl, window.location.origin);
      if (variantId) {
        url.searchParams.set('variant', variantId);
      }
      return url.toString();
    }

    function applyCurrentProductVariant(variantId) {
      if (!variantId) return;
      const productInfoRoot = document.querySelector('product-info') || document;
      const variants = window.productVariants || [];
      const optionNames = window.productOptions || [];
      const targetVariant = variants.find((variant) => String(variant.id) === String(variantId));

      if (targetVariant?.options) {
        productInfoRoot.querySelectorAll('select[name^="options["]').forEach((select) => {
          const match = select.name.match(/^options\[(.*)\]$/);
          if (!match) return;
          const idx = optionNames.indexOf(match[1]);
          if (idx !== -1 && targetVariant.options?.[idx]) {
            select.value = targetVariant.options[idx];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        optionNames.forEach((optionName, idx) => {
          const optionValue = targetVariant.options?.[idx];
          if (!optionValue) return;
          const escapedName = window.CSS?.escape
            ? CSS.escape(`${optionName}-`)
            : `${optionName}-`.replace(/"/g, '\\"');

          productInfoRoot.querySelectorAll(`variant-selects input[type="radio"][name^="${escapedName}"]`).forEach((input) => {
            if (String(input.value) !== String(optionValue)) return;
            if (!input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }

      updateSleepyheadMainProductVariantInputs(variantId);

      if (typeof window.__updateDealOffer === 'function') {
        window.__updateDealOffer(variantId);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());

      const labelValues = state.optionOrder
        .map((optionName) => state.selections[optionName])
        .filter(Boolean);
      const label = labelValues.join(' / ') || targetVariant?.title || 'Select options';
      document.querySelectorAll('.variant-preview').forEach((preview) => {
        preview.dataset.variantId = variantId;
        preview.innerHTML = `<p>${label}</p>`;
      });

      state.modal.setAttribute('aria-hidden', 'true');
      state.modal.style.display = 'none';
    }

    const applyBtn = document.getElementById('variant-apply');
    if (applyBtn) {
      applyBtn.addEventListener('click', (event) => {
        const matching = findMatchingItem(true) || findMatchingItem(false);
        if (!matching) return;
        const matchingId = matching.dataset.productId;
        const matchingUrl = matching.dataset.productUrl;
        const matchingVariantId = matching.dataset.variantId;
        if (state.variantMode && matchingVariantId) {
          event.preventDefault();
          event.stopImmediatePropagation();
          if (matchingId && state.currentProductId && matchingId !== state.currentProductId && matchingUrl) {
            window.location.href = buildVariantUrl(matchingUrl, matchingVariantId);
          } else {
            applyCurrentProductVariant(matchingVariantId);
          }
          return;
        }
        if (matchingId && state.currentProductId && matchingId !== state.currentProductId && matchingUrl) {
          event.preventDefault();
          event.stopImmediatePropagation();
          window.location.href = buildVariantUrl(matchingUrl, matchingVariantId);
        }
      }, true);
    }

    buildState();
    normalizeSelections(true);
    renderOptions();

    // Listen for reset event (fired when modal closes without Apply)
    // Restores linked selections to match the current product
    modal.addEventListener('linked-options:reset', () => {
      state.optionOrder.forEach((key) => {
        delete state.selections[key];
      });
      const currentVariantId = getCurrentVariantId();
      const currentItem = state.items.find(
        (item) =>
          item.dataset.productId === state.currentProductId &&
          (!currentVariantId || String(item.dataset.variantId) === String(currentVariantId))
      ) || state.items.find(
        (item) => item.dataset.productId === state.currentProductId && isItemPurchasable(item)
      ) || state.items.find(
        (item) => item.dataset.productId === state.currentProductId
      ) || state.items[0];
      if (currentItem?._optionMap) {
        state.optionOrder.forEach((key) => {
          if (currentItem._optionMap[key]) {
            state.selections[key] = currentItem._optionMap[key];
          }
        });
      }
      normalizeSelections(true);
      renderOptions();
    });
  }

  domReady(initLinkedOptionsModal);
})();


// Offer card
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".offer-slider-track");
  const cards = document.querySelectorAll(".offer-card");
  const btnNext = document.querySelector(".offer-arrow-right");
  const btnPrev = document.querySelector(".offer-arrow-left");

  if (!track || cards.length === 0) return;

  let index = 0;
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  function updateSlider() {
    const cardWidth = cards[0].offsetWidth + 15; // width + gap
    currentTranslate = -index * cardWidth;
    prevTranslate = currentTranslate;
    track.style.transform = `translateX(${currentTranslate}px)`;
    updateArrows();
  }

  function updateArrows() {
    // Disable left arrow if at start
    if (index === 0) {
      btnPrev.classList.add("is-disabled");
      btnPrev.classList.remove("is-active");
    } else {
      btnPrev.classList.remove("is-disabled");
      btnPrev.classList.add("is-active");
    }

    // Disable right arrow if at end
    if (index >= cards.length - 1) {
      btnNext.classList.add("is-disabled");
      btnNext.classList.remove("is-active");
    } else {
      btnNext.classList.remove("is-disabled");
      btnNext.classList.add("is-active");
    }
  }

  function getPositionX(e) {
    return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
  }

  function touchStart(e) {
    startPos = getPositionX(e);
    isDragging = true;
    track.style.transition = "none";
    track.style.cursor = "grabbing";
  }

  function touchMove(e) {
    if (!isDragging) return;

    const currentPosition = getPositionX(e);
    const diff = currentPosition - startPos;
    const cardWidth = cards[0].offsetWidth + 15;
    
    currentTranslate = prevTranslate + diff;

    // Add boundaries with resistance
    const maxTranslate = 0;
    const minTranslate = -(cards.length - 1) * cardWidth;

    if (currentTranslate > maxTranslate) {
      currentTranslate = maxTranslate + (diff * 0.2);
    } else if (currentTranslate < minTranslate) {
      currentTranslate = minTranslate + ((currentTranslate - minTranslate) * 0.2);
    }

    track.style.transform = `translateX(${currentTranslate}px)`;
  }

  function touchEnd() {
    if (!isDragging) return;
    
    isDragging = false;
    track.style.cursor = "grab";

    const cardWidth = cards[0].offsetWidth + 15;
    const movedBy = currentTranslate - prevTranslate;

    // Swipe threshold: 30% of card width
    const threshold = cardWidth * 0.3;

    if (movedBy < -threshold && index < cards.length - 1) {
      index++;
    } else if (movedBy > threshold && index > 0) {
      index--;
    }

    track.style.transition = "transform 0.3s ease-out";
    updateSlider();
  }

  // Touch events
  track.addEventListener("touchstart", touchStart);
  track.addEventListener("touchmove", touchMove);
  track.addEventListener("touchend", touchEnd);

  // Mouse events
  track.addEventListener("mousedown", touchStart);
  track.addEventListener("mousemove", touchMove);
  track.addEventListener("mouseup", touchEnd);
  track.addEventListener("mouseleave", () => {
    if (isDragging) touchEnd();
  });

  // Prevent context menu on long press
  track.addEventListener("contextmenu", (e) => {
    e.preventDefault();
  });

  // Prevent drag on images/links
  track.addEventListener("dragstart", (e) => {
    e.preventDefault();
  });

  // Arrow button events
  btnNext.addEventListener("click", () => {
    if (index < cards.length - 1) {
      index++;
      track.style.transition = "transform 0.3s ease-out";
      updateSlider();
    }
  });

  btnPrev.addEventListener("click", () => {
    if (index > 0) {
      index--;
      track.style.transition = "transform 0.3s ease-out";
      updateSlider();
    }
  });

  // Handle resize
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updateSlider();
    }, 150);
  });

  // Initialize
  track.style.cursor = "grab";
  updateSlider();
});

// Complementary Products Slider
(function() {
  'use strict';

  // One resize listener for the whole page instead of one per container: the block is
  // re-rendered on every size change, and per-container listeners would pile up pointing
  // at wrappers that have already been detached.
  const updaters = new Map();

  function initSlider(root) {
    const scope = root || document;
    const containers =
      scope.matches && scope.matches('.custom-complementary')
        ? [scope]
        : Array.from(scope.querySelectorAll('.custom-complementary'));

    containers.forEach(container => {
      if (container.dataset.ccSliderReady === 'true') return;

      const prevBtn = container.querySelector('.cc-prev');
      const nextBtn = container.querySelector('.cc-next');

      if (!prevBtn || !nextBtn) return;

      container.dataset.ccSliderReady = 'true';

      let currentIndex = 0;
      let currentWrapper = null;
      let itemCount = 0;
      let isDragging = false;
      let startPos = 0;
      let currentTranslate = 0;
      let prevTranslate = 0;

      function showVariantWrapper(variantId) {
        const wrappers = container.querySelectorAll('.cc-items-wrapper');
        
        // Hide all wrappers first
        wrappers.forEach(w => {
          w.classList.remove('active');
          w.style.display = 'none';
        });
        
        // Show and activate the selected wrapper
        const activeWrapper = container.querySelector(`[data-variant-id="${variantId}"]`);
        const fallbackWrapper = wrappers.length === 1 ? wrappers[0] : null;
        const targetWrapper = activeWrapper || fallbackWrapper;

        if (targetWrapper) {
          if (!activeWrapper && fallbackWrapper) {
            fallbackWrapper.dataset.variantId = String(variantId);
          }
          targetWrapper.style.display = 'flex';
          targetWrapper.classList.add('active');
          currentWrapper = targetWrapper;
          itemCount = targetWrapper.querySelectorAll('.cc-item').length;
          currentIndex = 0;
          currentTranslate = 0;
          prevTranslate = 0;
          updateSlider();
          setupDragAndSwipe();
        }
      }

      function updateSlider() {
        if (!currentWrapper || itemCount === 0) return;
        
        const items = currentWrapper.querySelectorAll('.cc-item');
        if (items.length === 0) return;
        
        const itemWidth = items[0].offsetWidth;
        const gap = 20;
        const offset = currentIndex * (itemWidth + gap);
        
        currentTranslate = -offset;
        prevTranslate = currentTranslate;
        currentWrapper.style.transform = `translateX(${currentTranslate}px)`;
        
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex >= itemCount - 1;
      }

      function getPositionX(e) {
        return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
      }

      function touchStart(e) {
        if (!currentWrapper) return;
        startPos = getPositionX(e);
        isDragging = true;
        currentWrapper.style.transition = 'none';
        currentWrapper.style.cursor = 'grabbing';
      }

      function touchMove(e) {
        if (!isDragging || !currentWrapper) return;

        const currentPosition = getPositionX(e);
        const diff = currentPosition - startPos;
        const items = currentWrapper.querySelectorAll('.cc-item');
        
        if (items.length === 0) return;
        
        const itemWidth = items[0].offsetWidth;
        const gap = 20;
        
        currentTranslate = prevTranslate + diff;

        // Add boundaries with resistance
        const maxTranslate = 0;
        const minTranslate = -(itemCount - 1) * (itemWidth + gap);

        if (currentTranslate > maxTranslate) {
          currentTranslate = maxTranslate + (diff * 0.2);
        } else if (currentTranslate < minTranslate) {
          currentTranslate = minTranslate + ((currentTranslate - minTranslate) * 0.2);
        }

        currentWrapper.style.transform = `translateX(${currentTranslate}px)`;
      }

      function touchEnd() {
        if (!isDragging || !currentWrapper) return;
        
        isDragging = false;
        currentWrapper.style.cursor = 'grab';

        const items = currentWrapper.querySelectorAll('.cc-item');
        if (items.length === 0) return;

        const itemWidth = items[0].offsetWidth;
        const gap = 20;
        const movedBy = currentTranslate - prevTranslate;

        // Swipe threshold: 30% of item width
        const threshold = (itemWidth + gap) * 0.3;

        if (movedBy < -threshold && currentIndex < itemCount - 1) {
          currentIndex++;
        } else if (movedBy > threshold && currentIndex > 0) {
          currentIndex--;
        }

        currentWrapper.style.transition = 'transform 0.3s ease-out';
        updateSlider();
      }

      function setupDragAndSwipe() {
        if (!currentWrapper) return;

        // Remove old listeners if any
        currentWrapper.removeEventListener('touchstart', touchStart);
        currentWrapper.removeEventListener('touchmove', touchMove);
        currentWrapper.removeEventListener('touchend', touchEnd);
        currentWrapper.removeEventListener('mousedown', touchStart);
        currentWrapper.removeEventListener('mousemove', touchMove);
        currentWrapper.removeEventListener('mouseup', touchEnd);
        currentWrapper.removeEventListener('mouseleave', handleMouseLeave);

        // Add new listeners
        currentWrapper.addEventListener('touchstart', touchStart, { passive: true });
        currentWrapper.addEventListener('touchmove', touchMove, { passive: true });
        currentWrapper.addEventListener('touchend', touchEnd, { passive: true });
        currentWrapper.addEventListener('mousedown', touchStart);
        currentWrapper.addEventListener('mousemove', touchMove);
        currentWrapper.addEventListener('mouseup', touchEnd);
        currentWrapper.addEventListener('mouseleave', handleMouseLeave);

        // Prevent context menu
        currentWrapper.addEventListener('contextmenu', (e) => {
          e.preventDefault();
        });

        // Prevent drag on images/links
        currentWrapper.addEventListener('dragstart', (e) => {
          e.preventDefault();
        });

        // Set cursor
        currentWrapper.style.cursor = 'grab';
      }

      function handleMouseLeave() {
        if (isDragging) touchEnd();
      }

      prevBtn.addEventListener('click', () => {
        if (currentIndex > 0) {
          currentIndex--;
          if (currentWrapper) {
            currentWrapper.style.transition = 'transform 0.3s ease-out';
          }
          updateSlider();
        }
      });

      nextBtn.addEventListener('click', () => {
        if (currentIndex < itemCount - 1) {
          currentIndex++;
          if (currentWrapper) {
            currentWrapper.style.transition = 'transform 0.3s ease-out';
          }
          updateSlider();
        }
      });

      updaters.set(container, updateSlider);

      // Which products belong on the card is decided server-side now - the block is
      // re-rendered for the selected variant - so there is only ever one wrapper to show.
      requestAnimationFrame(() => {
        const wrapper = container.querySelector('.cc-items-wrapper');
        if (wrapper) {
          showVariantWrapper(wrapper.dataset.variantId);
        }
      });
    });
  }

  // Called by product-info.js once it has swapped in the re-rendered block.
  function refreshSlider(container) {
    if (!container) return;
    updaters.delete(container);
    delete container.dataset.ccSliderReady;
    initSlider(container);
  }

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      updaters.forEach((update, container) => {
        if (!container.isConnected) {
          updaters.delete(container);
          return;
        }
        update();
      });
    }, 250);
  }, { passive: true });

  window.SleepyheadComplementary = { init: initSlider, refresh: refreshSlider };

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initSlider(), { once: true });
  } else {
    initSlider();
  }
})();
// Bought together

document.addEventListener("DOMContentLoaded", () => {
  const sliders = document.querySelectorAll(".bt-slider");

  sliders.forEach((slider) => {
    const wrapper = slider.parentElement;
    const dotsContainer = wrapper.querySelector(".bt-dots");
    const prevBtn = wrapper.querySelector(".bt-prev");
    const nextBtn = wrapper.querySelector(".bt-next");

    let cards = slider.querySelectorAll(".bt-card");
    const totalCards = cards.length;

    let cardWidth = 0;
    let currentIndex = 0; // Start from first real slide (no offset needed)

    // Clone slides for infinite loop (append first N at the end only)
    function cloneSlides() {
      if (!cards.length) return;
      const slidesToClone = Math.min(3, cards.length); // Never clone more than available
      for (let i = 0; i < slidesToClone; i++) {
        const clone = cards[i].cloneNode(true);
        clone.classList.add("clone");
        slider.appendChild(clone);
      }
      cards = slider.querySelectorAll(".bt-card"); // update
    }

    cloneSlides();

    // -------- SVG Dots --------
    const activeDotSVG = `<svg class="icon icon-dot-full active" width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.49122 9.90595H18.186C18.186 2.6862 14.102 6.10352e-05 9.27914 6.10352e-05C4.10144 6.10352e-05 0 3.58941 0 9.25494C0 9.47781 0.00581596 9.69481 0.0232689 9.91181H4.49122V9.90595ZM9.25587 3.46038C10.9488 3.46038 12.8977 4.1759 13.3282 7.0204H4.77629C5.46277 4.76826 7.23715 3.46038 9.25005 3.46038H9.25587Z" fill="#F15B25"></path><path class="odd-color" d="M17.0324 12.7752L14.5134 11.5553C14.1469 11.3794 13.8618 11.4967 13.6582 11.8544C12.8437 13.3031 11.494 14.0362 9.55677 14.0362C7.90456 14.0362 6.35707 13.2679 5.42624 11.8017C5.10627 11.4322 4.73976 11.6844 4.73976 11.6844C4.73976 11.6844 1.98802 12.9571 1.70295 13.2855C1.48188 13.5377 1.57497 13.7899 1.62732 13.8954C3.28535 16.3529 6.11273 17.778 9.35897 17.778C12.8786 17.778 15.9329 16.3822 17.3291 13.6433C17.5328 13.2562 17.4397 12.9571 17.0324 12.7811V12.7752Z" fill="#3A3A3B"></path></svg>`;
    const inactiveDotSVG = `<svg class="icon icon-dot-half" width="16" height="7" viewBox="0 0 16 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="odd-color" d="M15.4699 1.30063L12.9509 0.0807237C12.5844 -0.0952246 12.2993 0.0220755 12.0957 0.379837C11.2812 1.82848 9.93155 2.56159 7.99427 2.56159C6.34206 2.56159 4.79457 1.79329 3.86374 0.327052C3.54377 -0.0424389 3.17726 0.209753 3.17726 0.209753C3.17726 0.209753 0.425519 1.48245 0.140454 1.81088C-0.0806165 2.06307 0.0124652 2.31527 0.064824 2.42084C1.72285 4.87825 4.55023 6.30343 7.79647 6.30343C11.3161 6.30343 14.3704 4.90757 15.7666 2.16864C15.9703 1.78156 15.8772 1.48245 15.4699 1.3065V1.30063Z" fill="#3A3A3B"></path></svg>`;

    // -------- SET CARD WIDTH --------
    function setCardWidth() {
      const wrapperWidth = wrapper.offsetWidth;
      if (window.innerWidth > 990) cardWidth = wrapperWidth / 2.5;
      else if (window.innerWidth > 576) cardWidth = wrapperWidth / 1.5;
      else cardWidth = wrapperWidth;

      cards.forEach((c) => (c.style.minWidth = cardWidth + "px"));
      moveSlider(false);
    }

    // -------- CREATE DOTS --------
    function createDots() {
      dotsContainer.innerHTML = "";
      const dotCount = totalCards;
      for (let i = 0; i < dotCount; i++) {
        const dot = document.createElement("button");
        dot.classList.add("bt-dot");
        dot.innerHTML = i === 0 ? activeDotSVG : inactiveDotSVG;
        dot.addEventListener("click", () => {
          currentIndex = i; // No offset needed
          moveSlider(true);
        });
        dotsContainer.appendChild(dot);
      }
    }

    function updateDots() {
      const dots = dotsContainer.querySelectorAll(".bt-dot");
      let dotIndex = currentIndex % totalCards;
      if (dotIndex < 0) dotIndex += totalCards;
      dots.forEach((dot, idx) => {
        dot.innerHTML = idx === dotIndex ? activeDotSVG : inactiveDotSVG;
      });
    }

    // -------- MOVE SLIDER --------
    function moveSlider(transition = true) {
      slider.style.transition = transition ? "transform 0.35s ease" : "none";
      slider.style.transform = `translateX(${-currentIndex * cardWidth}px)`;
      prevTranslate = -currentIndex * cardWidth;
      currentTranslate = prevTranslate;
    }

    // -------- HANDLE LOOP --------
    slider.addEventListener("transitionend", () => {
      if (currentIndex >= totalCards) {
        currentIndex = 0;
        moveSlider(false);
      } else if (currentIndex < 0) {
        currentIndex = totalCards - 1;
        moveSlider(false);
      }
      updateDots();
    });

    // -------- DRAG & SWIPE --------
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let animationID = 0;

    function getPositionX(e) {
      return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
    }

    function dragStart(e) {
      isDragging = true;
      startPos = getPositionX(e);
      animationID = requestAnimationFrame(animation);
      slider.style.cursor = "grabbing";
    }

    function dragMove(e) {
      if (!isDragging) return;
      const currentPosition = getPositionX(e);
      currentTranslate = prevTranslate + currentPosition - startPos;
    }

    function dragEnd() {
      isDragging = false;
      cancelAnimationFrame(animationID);
      slider.style.cursor = "grab";

      const movedBy = currentTranslate - prevTranslate;
      
      // If moved enough, go to next/prev slide
      if (movedBy < -50 && currentIndex < cards.length - 1) {
        currentIndex++;
      } else if (movedBy > 50 && currentIndex > 0) {
        currentIndex--;
      }

      moveSlider(true);
    }

    function animation() {
      slider.style.transform = `translateX(${currentTranslate}px)`;
      if (isDragging) requestAnimationFrame(animation);
    }

    // Mouse events
    slider.addEventListener("mousedown", dragStart);
    slider.addEventListener("mousemove", dragMove);
    slider.addEventListener("mouseup", dragEnd);
    slider.addEventListener("mouseleave", dragEnd);

    // Touch events
    slider.addEventListener("touchstart", dragStart);
    slider.addEventListener("touchmove", dragMove);
    slider.addEventListener("touchend", dragEnd);

    // Prevent context menu
    slider.addEventListener("contextmenu", (e) => e.preventDefault());
    
    // Prevent image dragging
    slider.querySelectorAll("img").forEach((img) => {
      img.addEventListener("dragstart", (e) => e.preventDefault());
    });

    slider.style.cursor = "grab";

    // -------- ARROWS --------
    prevBtn.addEventListener("click", () => {
      currentIndex--;
      moveSlider(true);
    });
    nextBtn.addEventListener("click", () => {
      currentIndex++;
      moveSlider(true);
    });

    // -------- INIT --------
    function init() {
      setCardWidth();
      createDots();
      moveSlider(false);
    }

    init();
    window.addEventListener("resize", setCardWidth);
  });
});

// Product variant desctiption

document.addEventListener('DOMContentLoaded', function () {
    
    function updateVariantContent(variantId) {
        // If variantId not provided, try to get it from variant-preview or variant input
        if (!variantId) {
            const preview = document.querySelector('#variant-preview[data-variant-id]');
            if (preview) {
                variantId = preview.getAttribute('data-variant-id');
            } else {
                // Fallback: get from variant input
                const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
                if (variantInput) {
                    variantId = variantInput.value;
                }
            }
        }

        if (!variantId) return;

        // Update hidden input if present
        const input = document.querySelector('input.product-variant-id');
        if (input) input.value = variantId;

        // --- UNIVERSAL SECTION HANDLING ---
        // Find ALL elements on page that depend on variant ID
        const variantElements = document.querySelectorAll('[data-variant-id]');

        variantElements.forEach(el => {
            const elVariant = el.getAttribute('data-variant-id');

            // Hide all non-matching content
            if (String(elVariant) === String(variantId)) {
                el.style.display = '';
            } else {
                el.style.display = 'none';
            }
        });
    }

    // Run on load
    updateVariantContent();

    // Apply button
    const btn = document.getElementById('variant-apply');
    if (btn) btn.addEventListener('click', () => updateVariantContent());

    // Listen to variant change events from Shopify's variant selector
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            const variantId = data?.variant?.id;
            if (variantId) {
                updateVariantContent(String(variantId));
            }
        });
    }

    // Also listen to direct variant input changes as fallback
    document.addEventListener('change', (e) => {
        if (e.target.name === 'id' || e.target.closest('.variant-selector')) {
            const variantId = e.target.value;
            if (variantId) {
                updateVariantContent(String(variantId));
            }
        }
    });

});


// Sticky add to cart for mobile
document.addEventListener("scroll", function () {
  const stickyBar = document.querySelector(".sticky-atc-wrapper");
  const mainATC = document.querySelector("button[name='add']");
  
  if (!stickyBar || !mainATC) return;

  const rect = mainATC.getBoundingClientRect();

  if (rect.top < window.innerHeight && rect.bottom >= 0) {
    stickyBar.style.display = "none";
  } else {
    stickyBar.style.display = "block";
  }
});

// Read more

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".toggle-content").forEach(section => {
    const btn = section.querySelector(".read-more-toggle");
    if (!btn) return;

    btn.addEventListener("click", () => {
      const expanded = section.classList.toggle("expanded");
      btn.textContent = expanded ? "Read less" : "Read more";
      btn.setAttribute("aria-expanded", expanded);
    });
  });
});


//Gallery desktop slider

  (function () {
  // Replace with the section.id or run for multiple sections
  var sectionId = 'ul#Slider-Gallery-template--26174077829304__main'; // e.g. '1234567890' or dynamically pass in section.id

  function initGalleryControls(sectionId) {
    var galleryUL = document.getElementById('Slider-Gallery-' + sectionId);
    if (!galleryUL) return;

    var slides = Array.prototype.slice.call(galleryUL.querySelectorAll('.slider__slide'));
    if (!slides.length) return;

    var container = document.getElementById('MediaGallery-' + sectionId) || document.getElementById('GalleryViewer-' + sectionId);
    if (!container) container = galleryUL.closest('media-gallery') || galleryUL.parentElement;
    if (!container) return;

    var prevBtn = container.querySelector('.slider-button--prev');
    var nextBtn = container.querySelector('.slider-button--next');
    var counterCurrent = container.querySelector('.slider-counter--current');
    var counterTotal = container.querySelector('.slider-counter--total');

    // helper to set active slide by index
    function setActive(index) {
      index = Math.max(0, Math.min(index, slides.length - 1));
      // remove is-active from all slides
      slides.forEach(function(s) { s.classList.remove('is-active'); });
      var newSlide = slides[index];
      newSlide.classList.add('is-active');

      // update thumbnails (if present)
      try {
        var thumbnails = document.querySelectorAll('#Slider-Thumbnails-' + sectionId + ' .thumbnail-list__item');
        thumbnails.forEach(function (thumb) {
          var btn = thumb.querySelector('button.thumbnail');
          thumb.querySelector('button.thumbnail') && btn.removeAttribute('aria-current');
        });
        var matchingThumb = document.querySelector('#Slider-Thumbnails-' + sectionId + ' .thumbnail-list__item[data-media-position="' + (index+1) + '"] button.thumbnail');
        if (matchingThumb) matchingThumb.setAttribute('aria-current', 'true');
      } catch (e) {
        // ignore if thumbnails not present
      }

      // update counter
      if (counterCurrent) counterCurrent.textContent = (index + 1).toString();
      if (counterTotal) counterTotal.textContent = slides.length.toString();

      // Bring the active slide into view (works for simple slider layouts)
      // If your slider uses transforms, you may need to trigger the slider library API instead.
      try {
        newSlide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      } catch (e) { /* ignore */ }
    }

    // find current index
    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = currentIndex();
        setActive(idx - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var idx = currentIndex();
        setActive(idx + 1);
      });
    }

    // init counter
    if (counterTotal) counterTotal.textContent = slides.length.toString();
    if (counterCurrent && galleryUL.querySelector('.is-active')) {
      counterCurrent.textContent = (currentIndex() + 1).toString();
    } else if (counterCurrent) {
      counterCurrent.textContent = '1';
      slides[0].classList.add('is-active');
    }
  }

  // Wait until DOM is ready, then initialize (also re-run on Shopify section:load)
  function onReady() {
    // if you want to initialise for ALL product media sections:
    var galleryWrappers = document.querySelectorAll('[id^="MediaGallery-"]');
    if (galleryWrappers && galleryWrappers.length) {
      galleryWrappers.forEach(function (wrapper) {
        var sid = wrapper.id.replace('MediaGallery-', '');
        initGalleryControls(sid);
      });
    } else {
      // fallback: init single provided section id
      if (sectionId && sectionId !== 'SECTION_ID_HERE') initGalleryControls(sectionId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  // Re-initialize when Shopify fires section:load/section:reorder (helps with theme editor)
  document.addEventListener('shopify:section:load', function (e) { onReady(); });
  document.addEventListener('shopify:section:reorder', function (e) { onReady(); });
})();

// Ecom Rating - Variant-aware rating display
(function() {
  'use strict';

  function domReady(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb, { once: true });
    } else {
      cb();
    }
  }

  function parseRatingArray(ratingArray) {
    if (!ratingArray || !Array.isArray(ratingArray) || ratingArray.length === 0) return null;
    
    const result = {
      flipkart: null,
      amazon: null
    };

    if (ratingArray.length > 0 && ratingArray[0]) {
      const flipkartParts = ratingArray[0].split(':');
      if (flipkartParts.length === 2) {
        result.flipkart = {
          rating: flipkartParts[0].trim(),
          count: flipkartParts[1].trim()
        };
      }
    }

    if (ratingArray.length > 1 && ratingArray[1]) {
      const amazonParts = ratingArray[1].split(':');
      if (amazonParts.length === 2) {
        result.amazon = {
          rating: amazonParts[0].trim(),
          count: amazonParts[1].trim()
        };
      }
    }

    return result;
  }

  function buildRatingHTML(ratingData, flipkartImage, amazonImage) {
    if (!ratingData || (!ratingData.flipkart && !ratingData.amazon)) {
      return '';
    }

    let html = '';
    
    if (ratingData.flipkart) {
      html += `
        <div class="rating-item">
          <img src="${flipkartImage || 'https://cdn.shopify.com/s/files/1/0918/6479/3272/files/flipkart-image.png?v=1764763220'}" width="30" alt="flipkart">
          <span>${ratingData.flipkart.rating} <span class="star">★</span> | ${ratingData.flipkart.count}</span>
        </div>
      `;
    }

    if (ratingData.amazon) {
      html += `
        <div class="rating-item">
          <img src="${amazonImage || 'https://cdn.shopify.com/s/files/1/0918/6479/3272/files/amazon-image.png?v=1764763218'}" width="30" alt="amazon">
          <span>${ratingData.amazon.rating} <span class="star">★</span> | ${ratingData.amazon.count}</span>
        </div>
      `;
    }

    return html;
  }

  function updateRatingDisplay(variantId) {
    const wrappers = document.querySelectorAll('.rating-rotator-wrapper');
    if (!wrappers.length) return;

    // Use the first wrapper that has data attributes as the data source
    const dataSource = wrappers[0];
    const productRatingStr = dataSource.dataset.productRating || '[]';
    const variantRatingsStr = dataSource.dataset.variantRatings || '';
    const flipkartImage = dataSource.dataset.flipkartImage || '';
    const amazonImage = dataSource.dataset.amazonImage || '';

    // Parse product rating as JSON array
    let productRatingArray = [];
    try {
      productRatingArray = JSON.parse(productRatingStr);
    } catch (e) {
      console.warn('Failed to parse product rating:', e);
    }

    // Parse variant ratings map (format: "id1:::[...]|||id2:::[...]")
    const variantRatingsMap = {};
    if (variantRatingsStr) {
      const pairs = variantRatingsStr.split('|||');
      pairs.forEach(pair => {
        const [id, ratingJson] = pair.split(':::');
        if (id && ratingJson !== undefined) {
          try {
            const ratingArray = JSON.parse(ratingJson.trim());
            variantRatingsMap[id.trim()] = ratingArray;
          } catch (e) {
            console.warn('Failed to parse variant rating for', id, e);
          }
        }
      });
    }

    // Get rating for current variant or fallback to product rating
    const variantRatingArray = variantRatingsMap[variantId];
    const ratingArrayToUse = (variantRatingArray && variantRatingArray.length > 0) ? variantRatingArray : productRatingArray;

    const ratingData = parseRatingArray(ratingArrayToUse);
    const ratingHTML = buildRatingHTML(ratingData, flipkartImage, amazonImage);

    // Update ALL rating badges (desktop + mobile)
    wrappers.forEach(wrapper => {
      const rotator = wrapper.querySelector('.rating-rotator');
      if (rotator) {
        rotator.innerHTML = ratingHTML;
      }
    });
  }

  function getCurrentVariantId() {
    const variantInput = document.querySelector('input[name="id"]:checked, select[name="id"], input[type="hidden"][name="id"]');
    return variantInput ? variantInput.value : null;
  }

  function init() {
    const wrapper = document.querySelectorAll('.rating-rotator-wrapper');
    if (!wrapper.length) return;

    // Initialize with current variant
    const initialVariantId = getCurrentVariantId();
    if (initialVariantId) {
      updateRatingDisplay(initialVariantId);
    }

    // Listen for variant changes via change events
    document.addEventListener('change', (e) => {
      if (e.target.name === 'id' || e.target.closest('.variant-selector')) {
        const variantId = e.target.value;
        if (variantId) {
          updateRatingDisplay(variantId);
        }
      }
    });

    // Listen for variant changes via pub/sub
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const variantId = data?.variant?.id;
        if (variantId) {
          updateRatingDisplay(variantId);
        }
      });
    }
  }

  domReady(init);
})();
